import type {VacancyStatus} from '@/redux/v1/availability/models';

import {
  VACANCY_STATUS_AVAILABLE,
  VACANCY_STATUS_ERROR,
  VACANCY_STATUS_ON_REQUEST,
  VACANCY_STATUS_SOLD_OUT,
  VACANCY_STATUS_UNKNOWN,
} from '@/redux/v1/availability/models';

export const isVacancyStatusResolved = (
  vacancyStatus: VacancyStatus | null | undefined
): boolean => {
  return (
    vacancyStatus === VACANCY_STATUS_AVAILABLE ||
    vacancyStatus === VACANCY_STATUS_ON_REQUEST ||
    vacancyStatus === VACANCY_STATUS_UNKNOWN ||
    vacancyStatus === VACANCY_STATUS_SOLD_OUT ||
    vacancyStatus === VACANCY_STATUS_ERROR
  );
};

export const isVacancyAvailable = (
  vacancyStatus: VacancyStatus | null | undefined
): boolean => {
  return (
    vacancyStatus === VACANCY_STATUS_AVAILABLE ||
    vacancyStatus === VACANCY_STATUS_ON_REQUEST
  );
};
